import classNames from 'classnames';
import { Field } from 'formik';
import { useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';

import { Button } from '@/components/Button';
import { OnboardingCategory } from '@/types/onboarding';

const ITEMS_TO_SHOW = 5;

interface OnboardingCategorySectionProps {
  fieldName: string;
  category: OnboardingCategory;
  value: string | string[];
  multiple?: boolean;
}

export const OnboardingCategorySection = ({
  fieldName,
  category,
  value,
  multiple = false,
}: OnboardingCategorySectionProps) => {
  const { formatMessage } = useIntl();
  const [showAllItems, setShowAllItems] = useState(false);

  const hasReadMore = useMemo(() => category?.items?.length > ITEMS_TO_SHOW, [category.items]);

  const handleShowAllItems = useCallback(() => setShowAllItems((p) => !p), []);

  return (
    <div role="group" aria-labelledby="checkbox-categories-group">
      {category.title && <h4 className="title-h4 uppercase mt-8 mb-4">{category.title}</h4>}

      {category.items.map((item, i) => {
        const isActive = multiple ? value.includes(item.user_tag) : value === item.user_tag;
        return (
          <label
            key={item.user_tag}
            className={classNames('checkbox-as-chip', {
              active: isActive,
              '!hidden': i > ITEMS_TO_SHOW && !showAllItems,
              '!me-0': i === ITEMS_TO_SHOW && !showAllItems,
            })}
          >
            <Field type={multiple ? 'checkbox' : 'radio'} name={fieldName} value={item.user_tag} />
            {item.title}
          </label>
        );
      })}
      {hasReadMore && !showAllItems && (
        <Button onClick={handleShowAllItems} className="inline text-primary-300 font-bold m-0 py-0">
          {formatMessage({ id: 'global.seeMore' })}
        </Button>
      )}
    </div>
  );
};
